import { L1_TEAM_PATHS } from 'Deer/constants/routes';
import { useLocation, matchPath } from 'react-router-dom';

export const useDeerTeamType = () => {
  const location = useLocation();

  const teamType: keyof typeof L1_TEAM_PATHS = Object.keys(L1_TEAM_PATHS).find((module) =>
    matchPath(location.pathname, { path: L1_TEAM_PATHS[module], exact: false })
  ) as keyof typeof L1_TEAM_PATHS;

  return teamType;
};
